import { createSelector } from '@reduxjs/toolkit';
import {
  selectEMVCheckoutPageError,
  selectEmvPaymentModuleState,
  selectTransactionIsInError,
} from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-selectors';
import { selectHasActivePrinter } from '@ticketmaster/tm1pos-web-shared/printing/printingModule-selectors';
import { selectCartId, selectCartItemsPrice } from 'containers/App/selectors';
import { selectCurrentEvent, selectOrderIdToRetry } from 'containers/EventDetailPage/selectors/main';
import { selectCardPaymentEnabled, selectLinkGlobalAccountEnabled } from './checkout-selectors';
import {
  selectCheckoutInProgress,
  selectCreditCardFormData,
  selectFormToggles,
  selectHasPrintReceipt,
  selectLinkGlobalAccount,
  selectPhonePre,
  selectPrintReceiptData,
  selectUseEmailAsDelivery,
  selectUserInfoState,
} from './selectors';

export const selectCheckoutFormState = createSelector(
  [
    selectCheckoutInProgress,
    selectFormToggles,
    selectCartId,
    selectCreditCardFormData,
    selectUserInfoState,
    selectCurrentEvent,
    selectCartItemsPrice,
    selectOrderIdToRetry,
    selectPrintReceiptData,
    selectPhonePre,
    selectEMVCheckoutPageError,
    selectTransactionIsInError,
    selectUseEmailAsDelivery,
    selectEmvPaymentModuleState,
    selectHasActivePrinter,
    selectHasPrintReceipt,
    selectCardPaymentEnabled,
    selectLinkGlobalAccountEnabled,
    selectLinkGlobalAccount,
  ],
  (
    checkoutInProgress,
    formToggles,
    cart,
    creditCard,
    userInfo,
    currentEvent,
    { total },
    orderIdToRetry,
    printReceiptData,
    phonePre,
    emvCheckoutPageError,
    transactionIsInError,
    useEmailAsDelivery,
    { isEmvSupported, rules, deviceId: activePaymentDeviceId },
    hasActivePrinter,
    hasPrintReceipt,
    cardPaymentEnabled,
    linkGlobalAccountEnabled,
    linkGlobalAccount,
  ) => ({
    checkoutInProgress,
    ...formToggles,
    cartEmpty: !cart,
    ...creditCard,
    ...userInfo,
    currentEvent,
    cartTotal: total,
    orderIdToRetry,
    printReceiptData,
    phonePre,
    isEmvSupported,
    emvCheckoutPageError,
    hasEMVError: transactionIsInError,
    useEmailAsDelivery,
    hasActivePrinter,
    hasPrintReceipt,
    shouldRequireFullName: rules.shouldRequireFullName,
    hasActivePaymentDevice: activePaymentDeviceId !== null || !rules.shouldSelectDeviceFromList,
    cardPaymentEnabled,
    linkGlobalAccountEnabled,
    linkGlobalAccount,
  }),
);
